<template>
<div>
    <div class="px-4">
        <div class="d-flex justify-content-between">
            <h6 class="mt-2">
                <i class="fas fa-shopping-cart"></i> PENDIENTES
            </h6>
            <div class="btn-home">
                <button type="button" class="btn btn-outline-main" @click="mtdaddOrder">
                    <i class="fas fa-shopping-cart"></i> Nuevo
                </button>
            </div>

        </div>
        <div class="row mt-3">

            <div class="px-0 col-md-12" id="content-timelinetable">
                <table class="table table-responsive table-bordered text-xs">
                    <caption class="py-0 my-0"></caption>
                    <thead class="bg-main align-middle">
                        <tr class="text-white align-middle">
                            <th class="table-th-number">N°</th>
                            <th scope="col">FECHA</th>
                            <th scope="col">PROVEEDOR</th>
                            <th scope="col">METODO DE PAGO</th>
                            <th scope="col">TOTAL</th>
                            <th scope="col">ESTADO OC</th>
                            <th scope="col">N° FACTURA</th>
                            <th scope="col">F. FACTURA</th>
                            <th scope="col">F. VENCIMIENTO</th>
                            <th scope="col">S/ TOTAL FACTURA</th>
                            <th scope="col">S/ PAGADO FACTURA</th>
                            <th scope="col">S/ PENDIENTE F.</th>
                            <th scope="col">ACCIONES</th>
                        </tr>
                    </thead>
                    <tbody class="border border-main align-middle">
                        <tr class="text-center" v-if="cpData.length === 0">
                            <td colspan="13" class="text-center">No se encontraron resultados</td>
                        </tr>
                        <tr class="text-center" v-for="(item, index) in cpData" :key="index">
                            <td>
                                {{mtdNumber(index)}}
                            </td>
                            <td>{{ item.date | formatDate }} </td>
                            <td>{{ item.provider.name }}</td>
                            <td>{{ item.method ? item.method.toUpperCase() : '-' }}</td>
                            <td>{{ item.total }}</td>
                            <td>
                                <div class="text-center">
                                    <span v-if="item.state == 3" class="badge text-bg-danger text-xxs">Rechazado</span>
                                    <span v-if="item.state == 2" class="badge text-bg-success text-xxs">Aceptado</span>
                                    <span v-if="item.state == 1" class="badge text-bg-warning text-xxs">Por aprobar</span>
                                </div>
                            </td>
                            <td @click="mtdOutFocusInput(index, item.id)">
                                <input id="input-factura" type="text" class="form-control form-control-sm input-cantidad" 
                                :class="{'input-with-opacity': isButtonDisabled && posEditnumber !== index,}" style="text-align: center" 
                                placeholder="N° de Factura" v-if="item.number == null" v-model="bill[index].number" :disabled="item.state ==1" />
                                <span v-else>
                                    {{ item.number }}
                                </span>
                            </td>
                            <!---EDITAR FECHA DE EMISION FACTURA-->
                            <td @click="mtdOutFocusInput(index)">
                                <input id="input-f-factura" type="date" class="form-control form-control-sm input-cantidad" 
                                :class="{'input-with-opacity':isButtonDisabled && posEditnumber !== index,}" v-if="item.bill_date == null" 
                                v-model="bill[index].date" @change="mtdCalculeExperation(index)" :disabled="item.state ==1" />
                                <span v-else>
                                    {{ item.bill_date }}
                                </span>
                            </td>
                            <!---EDITAR FECHA DE VENCIMIENTO FACTURA-->
                            <td @click="mtdOutFocusInput(index)">
                                <input id="input-f-factura" type="date" class="form-control form-control-sm input-cantidad" 
                                :class="{'input-with-opacity':isButtonDisabled && posEditnumber !== index,}"  
                                v-if="item.bill_due_date == null" v-model="bill[index].due_date" :disabled="item.state ==1" />
                                <span v-else>
                                    {{ item.bill_due_date }}
                                </span>
                            </td>
                            <td @click="mtdOutFocusInput(index)">
                                <input id="input-cantidad" type="text" class="form-control form-control-sm input-cantidad" @input="validateAmount" 
                                :class="{'input-with-opacity':isButtonDisabled && posEditnumber !== index,}" style="text-align: center" 
                                placeholder="0.00" v-if="item.bill_total == null" v-model="bill[index].total" :disabled="item.state ==1"  />
                                <span v-else>
                                    {{ item.bill_total }}
                                </span>
                                <div v-if="!isValidInput[index]" class="error-message">
                                    Monto no permitido
                                </div>
                            </td>
                            <!---paid-->
                            <td>
                                {{ item.paid == null ? '-' : item.paid }}
                            </td>
                            <td>
                                {{ item.pending == null ? '-' : item.pending }}
                            </td>
                            <td class="align-middle" style="font-size: 11px">
                                <div class="d-flex justify-content-center">
                                    <a class="acciones text-center px-2 py-2" href="#" :class="{ disabledbutton: !isValidInput[index] }"  @click="openModal(item.id, index)">
                                        <i class="fas fa-plus text-white"></i>
                                    </a>
                                    <a v-if="item.bill_id" class="acciones-2 text-center px-2 py-2" href="#" title="Mostrar Depachos" style="margin-left: 2px" @click="openModalViewDispatch(item.bill_id, index)">
                                        <i class="fas fa-dolly text-white"></i>
                                    </a>
                                    <a class="acciones-4 text-center py-2" title="PDF OC" href="#" style="margin-left: 2px" @click="mtdViewDetail(item)">
                                        <i class="fas fa-eye text-white"></i>
                                    </a>
                                    <a class="acciones-3 text-center px-2 py-2" title="PDF OC" href="#" style="margin-left: 2px" @click="mtdViewPdf(item.id)">
                                        <i class="fas fa-file-pdf text-white"></i>
                                    </a>
                                    <a v-if="item.bill_id && !item.file" class="upload_pdf text-center px-2 py-2" title="Subir PDF Factura" style="margin-left: 2px; cursor: pointer" @click="upload(item)">
                                        <i class="fas fa-upload text-white"></i>
                                    </a>
                                    <a v-if="item.bill_id && item.file" class="upload_pdf text-center px-2 py-2" title="Subir PDF Factura" style="margin-left: 2px; cursor: pointer" @click="viewPdf(item.file)">
                                        <i class="fas fa-file-pdf text-white"></i>
                                    </a>
                                    <a class="acciones-5 text-center px-2 py-2 bg-info" v-if="showButton(item)" title="Agregar otra factura" href="#" style="margin-left: 2px"  @click="openModalStoreBill(item,index)">
                                        <i class="fas fa-file-invoice-dollar text-white"></i>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="cpData.length > 0" class="d-flex justify-content-center mb-2">
                <nav aria-label="Page navigation example ">
                    <ul class="pagination mb-0 ">
                        <li class="page-item">
                            <a class="page-link page" href="javascript:void(0)" @click="backPage">Anterior</a>
                        </li>
                        <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                            <a :class="selectPage === 1 ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(1)">1</a>
                        </li>
                        <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                            <span class="page-link">...</span>
                        </li>

                        <li v-for="(item, index) in limitedStepPagination" :key="index" class="page-item">
                            <a :class="selectPage === item ? 'page-link active' : 'page-link'" href="javascript:void(0)" @click="selectedPage(item)">{{ item }}
                            </a>
                        </li>
                        <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] <stepPagination.length - 1" class="page-item disabled">
                            <span class="page-link">...</span>
                        </li>
                        <li v-if=" limitedStepPagination[limitedStepPagination.length - 1] !== stepPagination.length" class="page-item">
                            <a :class="selectPage === limitedStepPagination.length + 2 ? 'page-link active':'page-link'" href="javascript:void(0)" @click="selectedPage(stepPagination.length)">{{ stepPagination.length }}
                            </a>
                        </li>
                        <li class="page-item">
                            <a class="page-link page" href="javascript:void(0)" @click="nextPage">Siguiente</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
    <cModalOtros :title="modal.title" :boo_modal="modal.modal_form" @mtdcloseModal="mtdcloseModal" @mtdViewPdf="mtdViewPdf"/>
    <cModalViewOthers :title="modalDetalle.title" :data="modalDetalle.item" :boo_modal="modalDetalle.modal_form" @mtdcloseModal="mtdcloseModal" />
    <RegisterPDF :boo_modal="modal_upload.boo_modal" :title="modal_upload.title" :id="modal_upload.id" :pa="modal_upload.pa" :page="modal_upload.page" 
    @mtdcloseModal="mtdCloseUpload" />
    <cModalStoreDispatch :title="modalStoreDispatch.title" :bill="modalStoreDispatch.bill_id" :cabecera="cabecera" :dataordendetalle="dataordendetalle" :boo_modal="modalStoreDispatch.modal_form" 
    @mtdCloseModalFactura="mtdCloseModalFactura" :dataBillDetailEdit="dataBillDetailEdit" :codigo="modalStoreDispatch.cod_purchase_order" 
    @addCampusRemi="addCampusRemi" @clearCampusRemi="clearCampusRemi" :modalRemi_val="modalRemi_val" :modalRemi_data="modalRemi_data"/>
    <cModalViewDispatch :title="modalViewDispatch.title" :dataDispatches="dataDispatches" :boo_modal="modalViewDispatch.modal_form" 
    @mtdCloseModalViewDispatches="mtdCloseModalViewDispatches" />
    <cModalGenerarFactura :title="modalStoreBill.title" :boo_modal="modalStoreBill.modal_form" :pa="modalStoreBill.pa"
    @closeModalStoreBill="closeModalStoreBill" @mtdShowModalStoreDispatch="mtdShowModalStoreDispatch" :purcharseOrder="purcharseOrder" />
</div>
</template>

<script>
import {mapActions} from "vuex";
import moment from "moment";
import cModalOtros from "../../modals/Oc/cModalRegisterOthers.vue";
import cModalViewOthers from "../../modals/Oc/cModalViewOthers.vue";
import RegisterPDF from '@/components/Logistica/modals/Oc/Actives/cModalUpload.vue';
import cModalStoreDispatch from "@/components/Logistica/modals/Oc/Others/cModalStoreDispatchOthers.vue";
import cModalViewDispatch from "@/components/Logistica/modals/Oc/Others/cModalViewDispatchOthers.vue";
import cModalGenerarFactura from "../../modals/Oc/cModalGenerarFactura.vue";
export default {
    name: 'logistica-ordendecompra-Otros',
    components: {
        cModalOtros,
        cModalViewOthers,
        RegisterPDF,
        cModalStoreDispatch,
        cModalViewDispatch,
        cModalGenerarFactura
    },
    data() {
        return {
            dataOrdes: [],
            modal: {
                title: "",
                modal_form: false,
            },
            modalDetalle: {
                title: "",
                modal_form: false,
                item:[],
            },
            //paginado
            page: 0,
            dataShow: [],
            totalPagesToShow: 5,
            selectPage: 1,
            stepPagination: [],
            //Factura
            search: "",
            modalStoreDispatch: {
                title: "",
                modal_form: false,
                cod_purchase_order: "",
                bill_id: null
            },
            modalViewDispatch: {
                title: "",
                modal_form: false,
            },
            modalPay: {
                title: "",
                modal_form: false,
            },
            modalCentral: {
                title: "",
                modal_form: false,
                bill: {}
            },
            modalStoreBill: {
                title: "",
                modal_form: false,
                pa: null
            },
            dataordendetalle: [],
            dataDispatches: [],
            dataBillPayment: [],
            cabecera: {
                name: "",
                id: null,
                ruc: "",
                total_igv: 0,
                total_sin_igv: 0,
                not_engraved: 0,
                activeButtonFormBill: false,
                observation: "",
            },
            bill: [],
            isButtonDisabled: false,
            posEditnumber: null,
            dataBillDetailEdit: [],
            filter_id: "",
            billpay: {
                bill_id: null,
                paid: "",
                pending: "",
                total: "",
                type: "",
            },
            purcharseOrder: {
                id: "",
                number: "",
                date: "",
                provider: "",
                provider_id: "",
                total: "",
                pending: "",
            },
            isValidInput: [],
            modal_upload: {
                boo_modal: false,
                title: '',
                id: 0,
                page: "",
                pa: null
            },
            modalRemi: {
                title: '',
                boo_modal: false,
            },
            modalRemi_val: null,
            modalRemi_data: {},
            pos: null
        };
    },
    computed: {
        cpData() {
            this.bill = Array(this.dataShow.length)
            .fill("")
            .map((_, index) => ({
                id: null,
                number: null,
                date: null,
                due_date: null,
                central_cost_id: "",
                purchase_orders_id: null,
                money: "soles",
                paid: null,
                days: this.dataShow[index].expiration_days,
                total: this.dataShow[index].total,
                detraction: 0,
            }));
            return this.dataShow;
        },
        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;

            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }

            return Array.from({
                    length: endPage - startPage + 1,
                },
                (_, i) => startPage + i
            );
        },

    },
    watch: {
        selectPage() {
            this.calculateData(10);
        },
        dataShow: {
            immediate: true,
            handler(newArrayDetalle) {
                this.isValidInput = Array(newArrayDetalle.length).fill(true);
            }
        }
    },
    created() {
        this.mtdGetData();
    },
    methods: {
        ...mapActions(["get", "post"]),
        //paginado
        mtdNumber: function (index) {
            return (index + 1) + ((this.selectPage - 1) * 10);
        },
        mtdGetData: function () {
            this.get({
                    url: this.$store.getters.get__url +
                        "/ordendecompra/indexOthers",
                    token: this.$store.getters.get__token
                })
                .then((response) => {
                    this.dataOrdes = response.data;
                    this.calculateData(10);
                })
                .catch((errors) => {});
        },
        mtdaddOrder: function () {
            this.modal= {
                title: "REGISTRAR ORDEN DE COMPRA",
                modal_form: true,
            };
        },
        mtdViewDetail: function (item) {
            this.modalDetalle= {
                title: "DETALLE DE ORDEN DE COMPRA",
                modal_form: true,
                item: item,
            };
        },
        calculateData(item) {
            if (!this.dataOrdes || !this.dataOrdes.length) {
                return (this.dataShow = []);
            }
            let filteredData = this.dataOrdes;
            let totalPages = Math.ceil(filteredData.length / item);
            this.stepPagination = Array.from({
                    length: totalPages,
                },
                (_, index) => index + 1
            );
            if (this.selectPage > totalPages) {
                this.selectPage = totalPages || 1; // Manejar el caso donde no haya datos
            }
            let startIndex = (this.selectPage - 1) * item;
            let endIndex = startIndex + (item - 1);
            this.dataShow = filteredData.slice(startIndex, endIndex + 1);
        },
        mtdcloseModal: function (opt) {
            this.modal.modal_form = false;
            this.modalDetalle.modal_form = false;
            if(opt == 0){
                this.mtdGetData();
            }
        },

        mtdViewPdf: function (id) {
            window.open(
                this.$store.getters.get__url +
                "/ordendecompra/viewpdfOthers/" + id,
                "_blank"
            );
        },

        //Factura
        showButton(item) {
            let total = 0
            this.dataOrdes.forEach(element => {
                if (element.id == item.id) {
                    total += parseFloat(element.bill_total);
                }
            })
            return item.bill_id && total !== parseFloat(item.total) && item.dispatchState !== 3;
        },

        mtdOutFocusInput(index) {
            if (this.posEditnumber !== index && this.posEditnumber !== null) {
                Swal.fire({
                    title: "Desea cambiar de fila?",
                    text: "Se borrarán los datos registrados!",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Si, cambiar!",
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.posEditnumber = index;
                    }
                });
            } else {
                this.posEditnumber = index;
            }

            this.isButtonDisabled = true;
        },

        validateAmount(event) {
            let sanitizedValue = event.target.value.replace(/[^0-9.]/g, "");

            const decimalCount = sanitizedValue.split(".").length - 1;
            if (decimalCount > 1) {
                sanitizedValue = sanitizedValue.slice(0, -1);
            }

            const decimalIndex = sanitizedValue.indexOf(".");
            if (decimalIndex !== -1) {
                const decimalPart = sanitizedValue.substring(decimalIndex + 1);
                sanitizedValue = `${sanitizedValue.substring(0,decimalIndex)}.${decimalPart.substring(0, 2)}`;
            }
            this.bill[this.posEditnumber].total = sanitizedValue;
            //validar que no sea mayor que el total
            const ocTotal = parseFloat(this.dataShow[this.posEditnumber].total).toFixed(2);
            const billTotal = parseFloat(sanitizedValue);
            let amount = parseFloat(sanitizedValue).toFixed(2);
            let validation = (amount > 0.00) ? billTotal > ocTotal : true
            if (validation == false) {
                this.bill[this.posEditnumber].total = sanitizedValue;
                this.isValidInput[this.posEditnumber] = true;

            } else {
                this.isValidInput[this.posEditnumber] = false;
            }
        },

        mtdCalculeExperation(index) {
            this.bill[index].due_date = this.bill[index].date;
        },

        //PRIMER BOTON
        openModal: function (id, index) {
            //si ya hay datos de factura abrir modal
            if (this.dataShow[index].bill_id !== null) {
                let total = this.dataShow[index].bill_total;
                this.mtdGetProducts(id, total);
                const state = this.dataShow[index].pending === 0 ? "CONTANDO" : "CREDITO";
                const type = this.dataShow[index].number.substring(0, 1) === 'B' ? "BOLETA" : "FACTURA";
                this.modalStoreDispatch = {
                    title: "DESPACHO DE LA " + type + " " + this.dataShow[index].number + " - " +
                        state + " / ESTADO: " + this.dataShow[index].bill_state,
                    modal_form: true,
                    bill_id: this.dataShow[index].bill_id,
                    cod_purchase_order: this.mtdGenerateCode(id),
                };
            } else {
                //verificar si no hay campos nulos
                if (
                    this.bill[index].number !== null &&
                    this.bill[index].money !== null &&
                    this.bill[index].date !== null &&
                    this.bill[index].total !== null
                ) {
                    if (this.posEditnumber !== index) {
                        Swal.fire({
                            icon: "error",
                            title: "El boton no pertenece a la fila",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    } else {
                        this.bill[index].purchase_orders_id = id;
                        Swal.fire({
                            title: "¿Desea registrar la factura?",
                            icon: "question",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Si, guardar",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.mtdInsertBill(id, index);
                            }
                        });
                    }
                } else {
                    if (this.posEditnumber === null) {
                        Swal.fire({
                            icon: "error",
                            title: "No hay factura registrada",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Debe registrar todo los campos",
                            showConfirmButton: false,
                            timer: 1500,
                        });
                    }
                }
            }
        },

        mtdGenerateCode(item) {
            if (0 < item && item < 10) {
                return " OC-000" + item;
            }

            if (9 < item && item < 100) {
                return " OC-00" + item;
            }
            if (99 < item && item < 1000) {
                return " OC-0" + item;
            }
            if (999 < item && item < 10000) {
                return " OC-" + item;
            }
        },

        mtdGetProducts: function (id, total) {
            this.get({
                    url: this.$store.getters.get__url + "/Others/getProducts/" + id,
                    token: this.$store.getters.get__token,
                })
                .then((response) => {
                    this.dataordendetalle = response.data.details;
                    this.dataDispatches = response.dispatch;
                    this.cabecera = {
                        id: response.data.proveedor.provider.id,
                        name: response.data.proveedor.provider.name,
                        ruc: response.data.proveedor.provider.ruc,
                        total_igv: total,
                        total_sin_igv: response.data.proveedor.total_sin_igv,
                        not_engraved: response.data.proveedor.not_engraved,
                        observation: response.data.proveedor.observation,
                    };
                    this.dataBillDetailEdit = Array(this.dataordendetalle.length)
                        .fill("")
                        .map((_, index) => ({
                            id_product_details: null,
                            incoming_quantity: null,
                            quantity_pending_order: null,
                            id_purcharse_order_detail: null,
                            state: 1,
                        }));
                })
                .catch((errors) => {});
        },

        mtdInsertBill: function (id, index) {
            this.post({
                url: this.$store.getters.get__url + "/Others/storeBill",
                token: this.$store.getters.get__token,
                params: this.bill[index],

            })
            .then((response) => {
                if (response.statusCode == 200) {
                    Swal.fire({
                        icon: "success",
                        title: "Factura registrada",
                        showConfirmButton: false,
                        timer: 1500,
                    });

                    const state = this.dataShow[index].pending === 0 ? "CONTANDO" : "CREDITO";
                    const type = this.bill[index].number.substring(0, 1) === 'B' ? "BOLETA" : "FACTURA";
                    this.modalStoreDispatch.title = "DESPACHO DE LA " + type + " " + response.data.bill.number + " - " +
                        state + " ESTADO: " + response.data.stateBill; //agregar el estado de la factura
                    this.modalStoreDispatch.bill_id = response.data.bill.id;
                    this.modalStoreDispatch.cod_purchase_order = this.mtdGenerateCode(id);
                    //completar los centra de costos
                    this.mtdGetProducts(id,response.data.bill.total);
                    this.mtdContinuenRegister();
                    this.mtdGetData();
                }
            })
            .catch((errors) => {});
        },

        mtdContinuenRegister() {
            this.modalCentral.modal_form = false;
            this.modalStoreDispatch.modal_form = true;
        },

        //BTN AGREGAR PDF FACTURA
        upload: function (item) {
            console.log("hola");
            let type = item.number.slice(0, 1) == 'F' ? 'FACTURA' : 'BOLETA';
            this.modal_upload = {
                boo_modal: true,
                title: 'AGREGAR DOC A LA ' + type + " - " + item.number,
                id: item.bill_id,
                page: 'logistica',
                pa: 1
            };
        },

        //BTN VER DESPACHOS
        openModalViewDispatch: function (bill_id, index) {
            if (this.dataShow[index].bill_id !== null) {
                const type = this.dataShow[index].number.substring(0, 1) === 'B' ? "BOLETA" : "FACTURA";
                const title = "DESPACHOS DE LA " + type + " " + this.dataShow[index].number;
                this.mtdGetDispatches(bill_id, title);
            } else {
                Swal.fire({
                    icon: "error",
                    title: "No hay factura registrada",
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        },

        mtdGetDispatches: function (idbill, titleModal) {
            this.get({
                url: this.$store.getters.get__url +
                    "/Others/getDispatches/" +
                    idbill,
                token: this.$store.getters.get__token,
            })
            .then((response) => {
                this.dataDispatches = response.data;
                if (this.dataDispatches.length > 0) {
                    this.modalViewDispatch = {
                        title: titleModal,
                        modal_form: true,
                    };
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "No hay despachos para mostrar",
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
            })
            .catch((errors) => {});
        },

        mtdCloseModalViewDispatches: function () {
            this.modalViewDispatch = {
                title: "",
                modal_form: false,
            };
            this.dataDispatches = [];
            this.posEditnumber = null;
            this.mtdGetData();
        },
        //FIN BTN VER DESPACHOS

        mtdCloseUpload: function () {
            this.modal_upload = {
                boo_modal: false,
                title: "",
                data: {},
                pa: null
            };
            this.mtdGetData();
        },

        //Boton Despachar
        mtdCloseModalFactura: function () {
            this.modalStoreDispatch = {
                title: "",
                modal_form: false,
            };
            this.posEditnumber = null;
            this.mtdGetData();
        },

        addCampusRemi() {
            this.modalRemi.title = 'Añadir datos de GUIA DE REMISION';
            this.modalRemi.boo_modal = true;
        },

        clearCampusRemi() {
            this.modalRemi_val = null;
            this.modalRemi_data = {};
            if (this.$refs.cModalCamposRemi) {
                this.$refs.cModalCamposRemi.clear();
            };
        },

        //Ver PDF
        viewPdf: function (ruta) {
            window.open(
                "https://clinicabm.v2.howertpi.com/assets/" + ruta,
                "_blank"
            );
        },


        //BTN AGREGAR NEW FACTURA
        openModalStoreBill: function (oc, index) {
            console.log(oc)
            let total = 0
            this.dataOrdes.forEach(element => {
                if (element.id == oc.id) {
                    total += parseFloat(element.bill_total);
                }
            })
            let debe = oc.total - total.toFixed(2)
            this.purcharseOrder = {
                id: oc.id,
                index: index,
                number: this.mtdGenerateCode(oc.id),
                date: oc.date,
                provider: oc.provider.name,
                provider_id: oc.provider_id,
                ruc: oc.provider.ruc,
                total: oc.total,
                pending: oc.pending,
                pendiente: debe.toFixed(2),
                centralCost: oc.provider,
            }
            this.modalStoreBill = {
                title: "Agregar Factura",
                modal_form: true,
                pa: 2
            };
        },

        closeModalStoreBill: function () {
            this.modalStoreBill = {
                title: "",
                modal_form: false,
                pa: null
            };
            this.posEditnumber = null;
            this.filter_id = "";
            this.modalCentral.modal_form = false;
        },

        mtdShowModalStoreDispatch: function (data) {
            this.mtdGetProducts(data.id,data.bill.total);
            this.closeModalStoreBill();
            const selectedOc = this.dataShow.find(
                (item) => item.id === data.id
            );
            //completar los datos para el modal de store
            this.modalStoreDispatch.title = data.title;
            this.modalStoreDispatch.bill_id = data.bill.id;
            this.modalStoreDispatch.cod_purchase_order = this.mtdGenerateCode(data.id);


            //En vez de abrir el modal de Central
            this.mtdGetData();

            //abrir el modal de registro de central de costos
            /* this.modalCentral = {
                title: "Central de Costos - " + data.bill.number,
                modal_form: true,
                bill: {
                    central: selectedOc.centrales,
                    totalBill: data.bill.total,
                    moneda: data.bill.money,
                    id: data.bill.id,
                    option: 1,
                }
            }; */

        },
        //FIN BTN AGREGAR NEW FACTURA

        //Pag
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage =
                this.selectPage < this.stepPagination.length ?
                this.selectPage + 1 :
                this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
    },
    filters: {
        formatDate(date) {
            return date != null ? moment(date).format("DD/MM/YYYY") : "-";
        },
    },

};
</script>
<style scoped>
.input-p::placeholder {
    font-size: 10px;
}

.input-p {
    font-size: 10px;
}

.input-with-opacity {
    opacity: 0.4;
    /* Otros estilos necesarios */
}

.input-factura {
    width: 100px;
    font-size: 11px;
}

#btn-save {
    color: #39b54a;
    font-size: 25px;
    margin: 0px 2px;
}

.acciones {
    background-color: #900052;
    border-radius: 10px;
    width: 25px;
}

.acciones-2 {
    background-color: #39b54a;
    border-radius: 10px;
    width: 25px;
}

.acciones-3 {
    background-color: blue;
    border-radius: 10px;
    width: 25px;
}

.acciones-4 {
    background-color: #ADD8E6; 
    color: white;
    border-radius: 10px;
    width: 25px;
}

.acciones-5 {
    border-radius: 10px;
    width: 25px;
}

.anterior-siguiente:focus {
    background: #900052;
}

.anterior-siguiente:hover {
    background: #bb026c;
}

#input-f-factura {
    font-size: 10px;
    width: 98px;
}

#select-moneda {
    font-size: 10px;
    width: 52px;
}

#select-remision {
    font-size: 10px;
    width: 62px;
}

#input-factura {
    font-size: 10px;
    width: 79px;
}

.error-message {
    font-size: 10px;
    color: red;
}

.disabledbutton {
    pointer-events: none;
    background-color: #e180b7;
    cursor: not-allowed;
    text-decoration: none;
}
</style>
